import { memo } from 'react';
import { AccountInfoTemplate } from 'components/templates/AccountInfoTemplate';

type Props = {};

export const AccountInfoPage = memo((_props: Props) => {
	return <AccountInfoTemplate />;
});
